import { Component } from '@angular/core';

@Component({
  selector: 'add-chart',
  standalone: true,
  imports: [],
  templateUrl: './add-chart.component.html',
  styleUrl: './add-chart.component.scss'
})
export class AddChartComponent {

}
